import React, { FC } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { isPhone } from '@helpers';
import TouchableElement from '@components/common/touchableElement';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { ImagesContainerMode, type ImagesContainerProps } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import type { WithColor } from '@styles/colors';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

import { AddImageIcon } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/AddImageIcon';
import { AddImageLabel } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/AddImageLabel';

export interface AddImageButtonProps
  extends WithColor,
    Pick<ImagesContainerProps, 'machineId' | 'documentRetrieveKey' | 'bg'> {
  panelViewMode?: boolean;
  noImages?: boolean;
  mode?: ImagesContainerMode;
  scale?: ScaleFunction;
  font?: typeof initialFont;
  onPress: () => void;
}

export const AddImageButton: FC<AddImageButtonProps> = ({
  C,
  panelViewMode,
  noImages,
  machineId,
  documentRetrieveKey,
  mode,
  bg,
  scale = initialScale,
  font = initialFont,
  onPress,
}) => (
  <TouchableElement testID={TEST_IDS.imagesContainer.addButton} onPress={onPress}>
    {({ pressHoverColor, boxStyle }) => (
      <View
        style={[
          boxStyle,
          {
            width: panelViewMode || noImages ? '100%' : scale(123),
            height: noImages ? (panelViewMode ? scale(174) : '100%') : scale(panelViewMode ? 74 : 83),
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            backgroundColor: C(pressHoverColor(noImages && isPhone ? bg : 'Button/Light/Tertiary')),
            marginRight: scale(panelViewMode ? 0 : 4),
            marginBottom: scale(panelViewMode ? 15 : 0),
          },
          !noImages && mode === ImagesContainerMode.ROW && { borderRadius: scale(SCREEN_BORDER_RADIUS) },
          mode === ImagesContainerMode.COLUMN && { borderRadius: scale(SCREEN_BORDER_RADIUS) },
        ]}
      >
        {!(noImages && isPhone && !panelViewMode) && <AddImageIcon color={pressHoverColor('Button/Light/Primary')} scale={scale} />}
        {noImages && (
          <AddImageLabel C={C} machineId={machineId} documentRetrieveKey={documentRetrieveKey} scale={scale} font={font} />
        )}
      </View>
    )}
  </TouchableElement>
);
